<div fxFlex fxLayout="column" class="channel-detail">
  <button fxFlex="none" fxFlexAlign="end" mat-button (click)="back()">
    <mat-icon>close</mat-icon>
  </button>
  <h2>{{ title }}</h2>
  <app-webchat-snippet
    [providerAccount]="providerAccount"
    [botConfig]="botConfig"
  ></app-webchat-snippet>
  @if (webchatSettings) {
    <div fxLayout="column">
      <mat-divider class="divider"></mat-divider>
      @if (webchatSettings) {
        <app-webchat-settings
          [showCurrentQueue]="true"
          [webchatSettings]="webchatSettings"
          (webchatSettingsChanged)="onWebchatSettingsChanged($event)"
        ></app-webchat-settings>
      }
      <button mat-raised-button (click)="updateSettings()">
        {{ updateSettingsLabel }}
      </button>
      @if (showFeedback()) {
        <p>{{ feedback }}</p>
      }
    </div>
  }
</div>
